module.exports = __webpack_public_path__ + "img/payment_generation.97c18030.svg";